import _implicitStylesheets from "./topCategories.css";
import _implicitScopedStylesheets from "./topCategories.scoped.css?scoped=true";
import _adsContentTitle from "ads/contentTitle";
import _adsTag from "ads/tag";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "top_categories": true
  },
  key: 0
};
const stc1 = {
  props: {
    "level": "2"
  },
  key: 1
};
const stc2 = {
  classMap: {
    "categories": true
  },
  attrs: {
    "grid": "",
    "axis": "row",
    "flow": "wrap"
  },
  key: 2
};
const stc3 = {
  "category": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, t: api_text, c: api_custom_element, k: api_key, b: api_bind, i: api_iterator, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [$cmp.showCategories ? api_element("div", stc0, [api_custom_element("ads-content-title", _adsContentTitle, stc1, [api_text(api_dynamic_text($cmp.props.title))]), !$cmp.store.isLoading ? $cmp.store.records ? api_element("div", stc2, api_iterator($cmp.store.records, function (category) {
    return api_custom_element("ads-tag", _adsTag, {
      classMap: stc3,
      props: {
        "props": category,
        "ariaLabel": category.ariaLabel,
        "variant": "button"
      },
      key: api_key(3, category.id),
      on: {
        "click": _m0 || ($ctx._m0 = api_bind($cmp.handleClick)),
        "analytics": _m1 || ($ctx._m1 = api_bind($cmp.handleAnalytics))
      }
    });
  })) : null : null]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6mej5j1hveb";
tmpl.legacyStylesheetToken = "undefined-_topCategories";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
